/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Banner_Remove_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Remove banner?" |
*
* @param {Tournament_Banner_Remove_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_banner_remove_confirm_title = /** @type {((inputs?: Tournament_Banner_Remove_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Banner_Remove_Confirm_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la bannière ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Eliminar banner?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover banner?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovere il banner?")
	return /** @type {LocalizedString} */ ("Remove banner?")
});